export default function Footer() {
    return (
      <>
        <footer className="footer">
  
          <div className="top-bar">

{/* Call Us */}
<a href="tel:+919766624663" className="top-item top-link">
  <div className="icon">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFD700" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
  </div>
  <div>
    <h4>Call Us</h4>
    <p>+91 9766624663</p>
  </div>
</a>

{/* Write to us */}
<a href="mailto:pritam@prgcars.in" className="top-item top-link">
  <div className="icon">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFD700" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="4" width="20" height="16" rx="2"/>
      <path d="M22 7L13.03 12.7a2 2 0 0 1-2.06 0L2 7"/>
    </svg>
  </div>
  <div>
    <h4>Write to us</h4>
    <p>pritam@prgcars.in</p>
  </div>
</a>

{/* Address → Google Maps */}
<a
  href="https://maps.app.goo.gl/45noprW4niXbrBih7"
  target="_blank"
  rel="noopener noreferrer"
  className="top-item top-link"
>
  <div className="icon">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFD700" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 21s-6-4.686-6-10a6 6 0 1 1 12 0c0 5.314-6 10-6 10z"/>
      <circle cx="12" cy="11" r="2.5"/>
    </svg>
  </div>
  <div>
    <h4>Address</h4>
    <p>Manish Nagar, Besa Road, Nagpur 440023</p>
  </div>
</a>

</div>
          {/* MAIN */}
          <div className="footer-container">
  
            <div className="footer-col">
              <h2 className="logo">PRG <span>CARS</span></h2>
              <p>
                Premium used car dealership delivering unmatched quality,
                trust, and experience.
              </p>
  
              <div className="socials">
  
                {/* Instagram */}
                <a href="https://www.instagram.com/prg_cars" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="5"/>
                    <circle cx="12" cy="12" r="4.5"/>
                    <circle cx="17.5" cy="6.5" r="0.8" fill="currentColor" stroke="none"/>
                  </svg>
                </a>
  
                {/* Facebook */}
                <a href="https://www.facebook.com/people/PRG-CARS-Mahindra-First-Choice-Nagpur/100065659562800/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                  </svg>
                </a>
  
                {/* WhatsApp */}
                <a href="https://wa.me/919766624663" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
                  </svg>
                </a>
  
              </div>
            </div>
  
            <div className="footer-col">
              <h4>Quick Links</h4>
              <ul>
                <li><a href="/">
                  <ArrowIcon /> Home
                </a></li>
                <li><a href="/">
                  <ArrowIcon /> Inventory
                </a></li>
              </ul>
            </div>
  
            <div className="footer-col">
              <h4>Our Services</h4>
              <ul>
                <li><ArrowIcon /> Used Car Sales</li>
                <li><ArrowIcon /> Inspection</li>
                <li><ArrowIcon /> Premium Cars</li>
              </ul>
            </div>
  
          </div>
  
          <div className="bottom">
            © {new Date().getFullYear()} PRG Cars. All rights reserved.
          </div>
  
        </footer>
  
  
  
        <style>{`
  
  .top-link {
    text-decoration: none;
    color: inherit;
    transition: transform 0.2s, background 0.2s;
    border-radius: 12px;
    padding: 8px;
    margin: -8px;
  }
  
  .top-link:hover {
    background: rgba(255, 215, 0, 0.05);
    transform: translateY(-2px);
  }
  
  .top-link:hover .icon {
    border-color: #FFD700;
  }
  
  .footer {
            color: #fff;
            padding: 20px 20px;
            font-family: sans-serif;
          }
  
          .top-bar {
            max-width: 1100px;
            margin: 10px auto 40px;
            background: rgba(255,255,255,0.05);
            backdrop-filter: blur(10px);
            border-radius: 16px;
            padding: 20px;
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 20px;
          }
  
          .top-item {
            display: flex;
            gap: 14px;
            align-items: center;
          }
  
          .icon {
            background: #1a1a1a;
            border: 1px solid #2a2a2a;
            padding: 12px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            width: 46px;
            height: 46px;
          }
  
          .top-item h4 {
            margin: 0 0 3px;
            font-size: 14px;
            font-weight: 600;
          }
  
          .top-item p {
            margin: 0;
            font-size: 13px;
            color: #aaa;
          }
  
          .footer-container {
            max-width: 1100px;
            margin: auto;
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
            gap: 40px;
          }
  
          .footer-col h4 {
            color: #FFD700;
            margin-bottom: 14px;
            font-size: 13px;
            letter-spacing: 0.06em;
            text-transform: uppercase;
          }
  
          .footer-col ul {
            list-style: none;
            padding: 0;
            margin: 0;
          }
  
          .footer-col li {
            margin-bottom: 10px;
            font-size: 13px;
            color: #888;
            cursor: pointer;
            transition: 0.25s;
            display: flex;
            align-items: center;
            gap: 6px;
          }
  
          .footer-col li:hover {
            color: #FFD700;
            transform: translateX(4px);
          }
  
          .footer-col li a {
            color: inherit;
            text-decoration: none;
            display: flex;
            align-items: center;
            gap: 6px;
            transition: 0.25s;
          }
  
          .footer-col li a:hover {
            color: #FFD700;
          }
  
          .logo {
            color: #fff;
            font-size: 22px;
            margin: 0 0 10px;
          }
  
          .logo span {
            color: #FFD700;
          }
  
          .footer-col p {
            font-size: 13px;
            line-height: 1.6;
          }
  
          .socials {
            display: flex;
            gap: 12px;
            margin-top: 16px;
          }
  
          .socials a {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            border-radius: 10px;
            background: #1a1a1a;
            border: 1px solid #2a2a2a;
            color: #888;
            transition: color 0.2s, border-color 0.2s, transform 0.2s;
          }
  
          .socials a:hover {
            color: #FFD700;
            border-color: #FFD700;
            transform: translateY(-2px);
          }
  
          .bottom {
            margin-top: 40px;
            text-align: center;
            font-size: 12px;
            color: #444;
            border-top: 1px solid #1a1a1a;
            padding-top: 16px;
          }
  
        `}</style>
      </>
    );
  }
  
  /* ── HELPERS ── */
  function ArrowIcon() {
    return (
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="#FFD700" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2.5 6h7M6.5 3l3 3-3 3"/>
      </svg>
    );
  }